export const PALETTE = {
    primary: {
        50: "#fcfcff",
        100: "#fbfbff",
        200: "#eef0ff",
        300: "#dde1ff",
        400: "#5468ff",
        500: "#4657d4",
        700: "#323e99",
    },
    secondary: {
        50: "#e8e8ec",
        100: "#d0d2da",
        200: "#b9bbc7",
        300: "#a2a4b4",
        400: "#1c2355",
        500: "#161c44",
        700: "#121636",
    },
    neutral: {
        50: "#f5f5f5",
        100: "#eeeeee",
        200: "#e6e6e6",
        300: "#dddddd",
        400: "#cccccc",
        500: "#aaaaaa",
        600: "#888888",
        700: "#666666",
        800: "#444444",
        900: "#292929",
    },
    error: { 50: "#fae9ed", 500: "#c9224a", 700: "#a11b3b", 900: "#79142c" },
    info: { 50: "#f0e7f4", 500: "#670c93", 700: "#520a76", 900: "#3e0758" },
    success: { 50: "#e6f7f4", 500: "#00ad8f", 700: "#008a72", 900: "#006856" },
    warning: { 50: "#fdf4e8", 500: "#ed8f1c", 700: "#be7216", 900: "#8e5611" },
    pink: { 500: "#ff2d55" },
    black: "#000000",
    white: "#ffffff",
};
export const FONT_STACK = "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, " +
    '"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, ' +
    '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
export const RADII = {
    none: "0",
    xs: "calc(var(--coras-brand-radius) / 6)",
    sm: "calc(var(--coras-brand-radius) / 3)",
    md: "calc(var(--coras-brand-radius) * 2 / 3)",
    lg: "var(--coras-brand-radius)",
    xl: "calc(var(--coras-brand-radius) * 7 / 6)",
    "2xl": "calc(var(--coras-brand-radius) * 4 / 3)",
    full: "9999px",
};
export const FONT_SIZES = {
    xxs: "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "2.25rem",
    "4xl": "3rem",
    "5xl": "3.5rem",
};
export const FONT_WEIGHTS = {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
};
